import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { QueryOptions } from '../../../../../../types/query/useQuery';
import { UserGradesResponseType } from '../types';
import { USER_GRADE_QUERY_KEYS } from './queryKeys';
import { GetUserGradesUsecaseImpl } from '../usecases/GetUserGradesUsecase';
import { UserGradesRepository } from '../repositories/UserGradesRepository';

type UseUserGradesQueryArgs<SelectReturnType> = {
  options: QueryOptions<UserGradesResponseType, unknown, SelectReturnType>;
};

export const useUserGradesQuery = <SelectReturnType>({
  options,
}: UseUserGradesQueryArgs<SelectReturnType>): UseQueryResult<SelectReturnType, unknown> => {
  const getUserGradesUsecase = new GetUserGradesUsecaseImpl(UserGradesRepository);

  return useQuery<UserGradesResponseType, unknown, SelectReturnType>(
    USER_GRADE_QUERY_KEYS.GRADES,
    () => getUserGradesUsecase.invoke(),
    { ...options },
  );
};
